export default {
  content: null,
  options: {},
  title: '',
  showButtons: true,

  text(title, text, options = {}) {
    this.open(title, { type: 'text', text }, options)
  },

  remote(title, url, options = {}) {
    this.open(
      title,
      {
        type: 'url',
        url,
        method: options.method || 'POST',
        values: options.values,
      },
      options,
    )
  },

  inline(title, selector, options = {}) {
    this.open(title, { type: 'selector', selector }, options)
  },

  confirm() {
    const confirmed = this.options.confirmed
    this.dispatch('modal-confirm')
    if (typeof this.options.confirm == 'function' &&
        this.options.confirm() === false) return
    this.close()
    this.dispatch('modal-confirmed')
    if (typeof confirmed == 'function') setTimeout(() => confirmed(), 5)
  },

  cancel() {
    this.dispatch('modal-cancel')
    if (typeof this.options.cancel == 'function') this.options.cancel()
    this.close()
  },

  open(title, content, options = {}) {
    this.dispatch('modal-open')
    this.content = content
    this.options = options
    this.title = title
  },

  close() {
    this.dispatch('modal-close')
    if (typeof this.options.close == 'function') this.options.close()
    this.content = null
    this.options = {}
    this.title = ''
    this.showButtons = true
  },

  dispatch(name, detail) {
    window.dispatchEvent(new CustomEvent(name, { detail }))
  },
}
